import { breakpoints, colors, spacing } from '@chegg-ui/theme';
import styled, { css } from 'styled-components';
var BOTTOM_ADD_TRAY_MOBILE_HEIGHT = 50;
export var SubmitSectionContainer = styled.div.withConfig({
  componentId: "pilwl6-0"
})(["display:flex;margin:", ";margin-right:", ";justify-content:flex-end;gap:", ";@media screen and (max-width:", "){margin-right:", ";gap:", ";}", " ", ""], spacing.px16, function (_ref) {
  var adsEnabled = _ref.adsEnabled;
  return adsEnabled ? spacing.px24 : spacing.px32;
}, function (_ref2) {
  var adsEnabled = _ref2.adsEnabled;
  return adsEnabled ? spacing.px12 : spacing.px24;
}, breakpoints.md.min, spacing.px12, spacing.px24, function (_ref3) {
  var adsEnabled = _ref3.adsEnabled;
  return adsEnabled ? css(["button{padding:", " ", " 6px;}"], spacing.px8, spacing.px12) : "";
}, function (props) {
  return props.showButtonsInVertical ? css(["@media screen and (max-width:", ") and (min-width:", "){flex-direction:column-reverse;gap:", ";margin-right:", ";}@media screen and (max-width:450px){flex-direction:column-reverse;gap:", ";margin-right:", ";}"], breakpoints.lg.max, breakpoints.md.min, spacing.px12, spacing.px16, spacing.px12, spacing.px16) : "";
});
export var Divider = styled.hr.withConfig({
  componentId: "pilwl6-1"
})(["border-top:1px solid ", ";margin:0;"], colors.greyLight);
export var FormSubmitWrapper = styled.div.withConfig({
  componentId: "pilwl6-2"
})(["position:absolute;bottom:0;left:0;right:0;background:", ";@media screen and (max-width:", "){bottom:", ";}"], colors.white, breakpoints.sm.max, function (_ref4) {
  var adsEnabled = _ref4.adsEnabled;
  return adsEnabled ? "".concat(BOTTOM_ADD_TRAY_MOBILE_HEIGHT, "px") : 0;
});